export default function numberToSide(number: number) {
  switch (number) {
    case 0:
      return "r";
    case 1:
      return "l";
    case 2:
      return "u";
    case 3:
      return "d";
    case 4:
      return "f";
    case 5:
      return "b";
    default:
      console.error("unknown number");
  }
}
